import Model from './Model';
import ScheduledServiceTime from './ScheduledServiceTime';

export default class Job extends Model {
  resource() {
    return 'jobs';
  }

  scheduledServiceTimes() {
    return this.hasMany(ScheduledServiceTime);
  }
}
